import { h, Fragment } from "preact";
import { useState, useRef } from "preact/compat";
import SelectInput from "./SelectInput";
import DatePicker from "react-datepicker";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
// import "../../../node_modules/react-datepicker/dist/react-datepicker.css";

export default function QualityForm({
  subject,
  state,
  setAdvFields,
  changeInput,
  errors,
  address,
}) {
  const subj = "29dd84b2-e841-4b3a-b457-4082aba6cddc"; //Отсутствие эл. энергии
  if (subject != subj) return;

  const fieldsName = {
    fio: "Фамилия, имя и отчество",
    address: "Место жительства",
    birthday: "Дата рождения",
    place_of_birth: "Место рождения",
    passport: "Серия и номер паспорта",
    violation: "Даты и время зафиксированных нарушений",
    way: "Способ обратной связи",
  };
  const requiredFields = [
    "fio",
    "address",
    "birthday",
    "place_of_birth",
    "passport",
    "violation",
    "way",
  ];

  const way_providing = [
    { name: "В личном кабинете" },
    { name: "По телефону" },
    { name: "По электронной почте" },
  ];

  const [startDate, setStartDate] = useState();
  const changeBirthday = (d) => {
    changeInput("birthday", d.toLocaleDateString())();
    setStartDate(d);
  };

  const getFieldsData = () => {
    let values = {};
    for (let key of Object.keys(fieldsName)) {
      values[key] = "";
    }
    values.address = address;
    values.way = way_providing[0].name;
    return { values: values, requireds: requiredFields, names: fieldsName };
  };
  setAdvFields(getFieldsData());

  const refPassport = useRef();
  if (refPassport.current) {
    $(refPassport.current)
      .inputmask({
        mask: "9999-999999",
        clearIncomplete: true,
        oncomplete: function (e) {
          changeInput("passport", e.target.value)();
        },
        onincomplete: function () {
          changeInput("passport", "")();
        },
      })
      .val(state.passport);
  }

  return (
    <Fragment>
      <div
        className={`form-field form-field_dir-min-md_row form-block__item form-block__item_mgt_xs ${
          errors.fio ? "form-field_state_error" : ""
        }`}
      >
        <div className="form-field__inner">
          <div className="form-field__title-row">
            <label className="form-field__title">
              Фамилия, имя и отчество*
            </label>
          </div>
          <div className="form-field__input-row">
            <input
              className="input form-field__input false"
              value={state.fio}
              placeholder=""
              onChange={changeInput("fio")}
            />
          </div>
        </div>
      </div>
      <div
        className={`form-field form-field_dir-min-md_row form-block__item form-block__item_mgt_xs ${
          errors.address ? "form-field_state_error" : ""
        }`}
      >
        <div className="form-field__inner">
          <div className="form-field__title-row">
            <label className="form-field__title">Место жительства*</label>
          </div>
          <div className="form-field__input-row">
            <input
              className="input form-field__input false"
              value={state.address}
              onChange={changeInput("address")}
            />
          </div>
        </div>
      </div>
      <div
        className={`form-field form-field_dir-min-md_row form-block__item form-block__item_mgt_xs ${
          errors.birthday ? "form-field_state_error" : ""
        }`}
      >
        <div className="form-field__inner">
          <div className="form-field__title-row">
            <label className="form-field__title">Дата рождения*</label>
          </div>
          <div className="form-field__input-row">
            <DatePicker
              selected={startDate}
              onChange={(date) => changeBirthday(date)}
              dateFormat="dd/MM/yyyy"
              maxDate={new Date()}
              showMonthDropdown
              useShortMonthInDropdown
              showYearDropdown
              yearDropdownItemNumber={70}
              scrollableYearDropdown
              className="form-field__input input"
            />
          </div>
        </div>
      </div>
      <div
        className={`form-field form-field_dir-min-md_row form-block__item form-block__item_mgt_xs ${
          errors.place_of_birth ? "form-field_state_error" : ""
        }`}
      >
        <div className="form-field__inner">
          <div className="form-field__title-row">
            <label className="form-field__title">Место рождения*</label>
          </div>
          <div className="form-field__input-row">
            <input
              className="input form-field__input false"
              value={state.place_of_birth}
              onChange={changeInput("place_of_birth")}
            />
          </div>
        </div>
      </div>
      <div
        className={`form-field form-field_dir-min-md_row form-block__item form-block__item_mgt_xs ${
          errors.passport ? "form-field_state_error" : ""
        }`}
      >
        <div className="form-field__inner">
          <div className="form-field__title-row">
            <label className="form-field__title">Серия и номер паспорта*</label>
          </div>
          <div className="form-field__input-row">
            <input
              className="input form-field__input false"
              value={state.passport}
              onChange={changeInput("passport")}
              ref={refPassport}
            />
          </div>
        </div>
      </div>
      <div
        className={`form-field form-field_dir-min-md_row form-block__item form-block__item_mgt_xs ${
          errors.violation ? "form-field_state_error" : ""
        }`}
      >
        <div className="form-field__inner">
          <div className="form-field__title-row">
            <label className="form-field__title">
              Даты и время зафиксированных нарушений*
            </label>
          </div>
          <div className="form-field__input-row">
            <input
              className="input form-field__input false"
              value={state.violation}
              onChange={changeInput("violation")}
            />
          </div>
        </div>
      </div>
      <div class="form-field form-field_dir-min-md_row form-block__item form-block__item_mgt_xs">
        <div className="form-field__inner">
          <div className="form-field__title-row">
            <label className="form-field__title">
              Способ оказания обратной связи
            </label>
          </div>
          <div className="form-field__input-row">
            <SelectInput
              onChange={changeInput("way")}
              placeholder=""
              getItemName={(item) => item.name}
              getItemValue={(item) => item.name}
              items={way_providing}
              checkedItem={state.way}
              isCheckedValue={(item) => item.name === state.way}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
}
